module.exports = __webpack_public_path__ + "067deaefd76d2630f25ea3a41c56de1c.MP3";